import { openModal } from "action/modal/openModal";
import { addItem } from "action/shopping-cart/addItem";
import { addToCartLocation } from "action/utils/addToCartLocation";
import { AMP_ADD_TO_CART_LOCATIONS } from "analytics/amplitude/amplitudeEvents";
import classNames from "classnames";
import { VEHICLE_FITMENT } from "constant/shared-constants";
import { RootState } from "interfaces/generics.type";
import { ShoppingCart } from "lucide-react";
import { useTranslation } from "next-i18next";
import { useDispatch, useSelector } from "react-redux";
import { isApparelProduct } from "util/product/apparel";
import { isDeliveryMethodUnAvailable } from "../../../util/helper/isDeliveryMethodUnAvailable";
import { isPickUpDeliveryAvailable } from "../../../util/helper/isPickUpDeliveryAvailable";
import styles from "./add-to-cart-button.module.scss";
import Button from "./Button";
import PAButton, { BUTTON_TYPE } from "./PAButton";
function AddtoCartButton(props: any) {
  const { t } = useTranslation("product");
  const {
    onClick, className = "btn btn-danger", label = t("Add to Cart"), pickUpAvailable: productPickUpAvailable,
    shippingAvailable, product, quantity, addingToCartLocation = AMP_ADD_TO_CART_LOCATIONS.PRODUCT_PAGE,
    showLabel = true, merchandiseSizes, buttonRef, variant = "danger", categoryPage = false, isPrimaryButton = false, ...restProsp
  } = props;
  const dispatch = useDispatch();
  const { availableDeliveryMethods } = useSelector((state: RootState) => state.utils);
  const isApparel = isApparelProduct(product);

  function handleAddItemCart() {
    const vehicle = undefined;
    dispatch(addToCartLocation(addingToCartLocation));

    if (isApparel && merchandiseSizes?.length) {
      dispatch(openModal("apparelSizeModal", {
        title: "Select Size",
        merchandiseSizes,
        // merchandiseColors: filterOptions.merchandiseColors?.map((el) => el.bucket),
        // airFreshenerColors: filterOptions.airFreshenerColors?.map((el) => el.bucket),
        // airFreshenerScents: filterOptions.airFreshenerScents?.map((el) => el.bucket),
        product,
      }));
    } else {
      dispatch(addItem(product,
        vehicle,
        { skipValidation: (product.fitment === VEHICLE_FITMENT.UNIVERSAL || isApparel), quantity },
        ({ fitmentOptionsDetails, updatedProduct }) => dispatch(openModal("shoppingCart", { product: updatedProduct, fitmentOptionsDetails }))))
        .catch(() => {});
    }
  }

  function handleNotifyMeItem() {
    dispatch(openModal("notifyMe", product));
  }

  /* Dont add empty array fix
  as it disable add to cart button first & then enable it. That's why (shipmentAvailable !== undefined) this check is added
  PostalCode -> L6W 0A0 & URL => http://localhost:3000/bosch-battery-s6508b */
  // const disabledAddToCart = shipmentAvailable !== undefined && !pickUpAvailable && !shipmentAvailable;
  const { shipmentAvailable } = isPickUpDeliveryAvailable(availableDeliveryMethods);
  let disabledAddToCart = false;

  // response from Product data
  if (shippingAvailable !== undefined) {
    disabledAddToCart = !productPickUpAvailable && !shippingAvailable;
  }
  // response from https://integ.partsavatar.ca/api/get-product-delivery-details-v2
  if (shipmentAvailable !== undefined) {
    disabledAddToCart = isDeliveryMethodUnAvailable(availableDeliveryMethods);
  }

  if (product && product.outOfStock && !disabledAddToCart) {
    if (!showLabel) {
      return (
        <PAButton
          onClick={handleNotifyMeItem}
          buttonType={BUTTON_TYPE.NORMAL}
          className={styles.notify_me_icon}
        >
          <i
            className="fa fa-bell-o"
          />
        </PAButton>
      );
    }
    return (
      <PAButton
        onClick={handleNotifyMeItem}
        buttonType={BUTTON_TYPE.PRIMARY}
        className={styles.notify_me_button}
        bold
      >
        {t("Notify Me")}
      </PAButton>
    );
  }

  if (categoryPage) {
    return (
      <div
        onClick={onClick || handleAddItemCart}
        {...restProsp}
        id={`add-to-cart-${product?.sku}`}
        className={styles.category_page_add_to_cart}
      >
        {t("Add to Cart")}
      </div>
    );
  }

  if (!showLabel) {
    return (
      <div
        onClick={onClick || handleAddItemCart}
        {...restProsp}
        id={`add-to-cart-${product?.sku}`}
        className={styles.cart_icon}
      >
        <i
          className="fa fa-cart-plus"
        />
      </div>
    );
  }
  // className="pip-svg-icon pip-btn__icon"

  if (isPrimaryButton) {
    return (
      <PAButton widthAuto className={styles.primary_button} onClick={onClick || handleAddItemCart}>
        {t("Add to Cart")}
      </PAButton>
    );
  }

  return (
    <>
      <Button
        variant={variant}
        id={`add-to-cart-${product?.sku}`} // id is used in testing
        disabled={disabledAddToCart}
        onClick={onClick || handleAddItemCart}
        buttonRef={buttonRef}
        {...restProsp}
        leftIcon={<ShoppingCart size={20} />}
        fullWidth
        className={classNames(styles.add_to_cart, className)}
      >
        {label}
      </Button>
    </>
  );
}

export default AddtoCartButton;
